import { defineComponent, h } from 'vue';
import { t } from '@/ui/i18n/i18n';

export const ConductInspectionItemQuestionQrCode = defineComponent({
  name: 'ConductInspectionItemQuestionQrCode',
  setup() {
    return function render() {
      return h('div', [t('inspections.scan-qr-code')]);
    };
  },
});
